import { createSlice } from "@reduxjs/toolkit";
import { merge } from "lodash";
import { exportDataModalState } from "components/modal/export-data/types";
import { importDataModalState } from "components/modal/import-data/types";
import { ModalName } from "components/modal/types";
export const modalNames = Object.values(ModalName).filter((k) => !Number.isNaN(Number(k)))
    .map((k) => k);
const initialState = modalNames
    .reduce((acc, val) => {
    acc[val] = {
        content: {
            id: "",
            modalName: val
        },
        isOpen: false,
        title: "",
        type: "action"
    };
    return acc;
}, {});
Object.assign(initialState[ModalName.ExportData], exportDataModalState);
Object.assign(initialState[ModalName.ImportData], importDataModalState);
const slice = createSlice({
    initialState,
    name: "modalsReducers",
    reducers: {
        changeExportDataModalState: (state, action) => {
            if (state && state[ModalName.ExportData] && action.payload) {
                Object.assign(state[ModalName.ExportData], action.payload);
            }
        },
        changeImportDataModalState: (state, action) => {
            if (state && state[ModalName.ImportData] && action.payload) {
                Object.assign(state[ModalName.ImportData], action.payload);
            }
        },
        changePdfModalState: (state, action) => {
            if (state && state[ModalName.DownloadPdfModal] && action.payload) {
                Object.assign(state[ModalName.DownloadPdfModal], action.payload);
            }
        },
        closeModal: (state, action) => {
            if (state && state[action.payload]) {
                state[action.payload].isOpen = false;
                state[action.payload].content.workshop = {};
                state[action.payload].content.parameters = {};
                state[action.payload].content.metadata = {};
            }
        },
        openModal: (state, action) => {
            if (state && state[action.payload.content.modalName]) {
                if (modalNames.filter((name) => name !== action.payload.content.modalName && state[name].isOpen).length >= 2) {
                    throw new Error("According to the guidelines, we shouldn't have more than 2 modals open at the same time." +
                        "If by any chance you see this message, then some design decisions need to be revisited.");
                }
                const modal = state[action.payload.content.modalName];
                modal.isOpen = true;
                modal.title = action.payload.title;
                modal.type = action.payload.type;
                modal.content = merge(modal.content, action.payload.content);
            }
        },
        setContentParameter: (state, action) => {
            if (state && state[action.payload.modalName]) {
                const modal = state[action.payload.modalName];
                modal.content.parameters = action.payload.parameters;
            }
        }
    }
});
export const modalsReducers = slice.reducer;
export const { openModal, closeModal, setContentParameter, changePdfModalState, changeExportDataModalState, changeImportDataModalState } = slice.actions;
